/* ===== Anadita Luxe — hero parallax ===== */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var layers = [].slice.call(document.querySelectorAll('[data-parallax]'));
  if (!layers.length) return;
  var ticking = false;
  function update() {
    layers.forEach(function (layer) {
      var root = layer.closest('[data-parallax-root]') || layer.parentNode;
      var rect = root.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      var progress = (rect.top + rect.height / 2 - window.innerHeight / 2) / window.innerHeight;
      layer.style.transform = 'translate3d(0,' + (progress * 14).toFixed(2) + '%,0)';
    });
    ticking = false;
  }
  function onScroll() { if (!ticking) { window.requestAnimationFrame(update); ticking = true; } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
